module.exports = __webpack_public_path__ + "media/images/globe-8bf4e8a8220e576feee55482e2f86937.png";